import { BnbChain, USDT } from '@ui/uikit/components/icons/poly';

export const PredictionPairButton = () => {
  return (
    <button className="msq-btn msq-btn-lg cursor-default bg-base-bg-secondary">
      <span className="flex mr-1.5">
        <BnbChain className="icon-xs" />
        <USDT className="icon-xs -ml-2" />
      </span>
      BNB / USDT Price
    </button>
  );
};
